import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {IntlProvider, injectIntl} from 'react-intl';

// Hack to get intl use in react middleware (sagas)
export const intlStore = {};
class IntlStoreProvider extends Component {
  constructor(props) {
    super(props);
    intlStore.intl = props.intl;
  }
  render() {
    return this.props.children;
  }
}

IntlStoreProvider.propTypes = {
  intl: PropTypes.any,
  children: PropTypes.node
};

const IntlStoreProviderWrapper = injectIntl(IntlStoreProvider);

class LocaleProvider extends Component {
  render() {
    const messages = this.props.messages;
    if (!messages) {
      return null;
    }
    return (
      <IntlProvider
        key={this.props.locale}
        locale={this.props.locale}
        defaultLocale={this.props.defaultLocale}
        messages={messages}
      >
        <IntlStoreProviderWrapper>
          {this.props.children}
        </IntlStoreProviderWrapper>
      </IntlProvider>
    );
  }
}

LocaleProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  defaultLocale: PropTypes.string.isRequired,
  messages: PropTypes.object,
  children: PropTypes.node
};

export default LocaleProvider;
